import React, { useState } from 'react';
import { ButtonFieldIcon, ButtonField, Iconsvg, SrOnly, Tooltip, TooltipBody } from '@wk/components-react16';
import AddPrivilege from './modal/AddPrivilege';
import AddRole from './modal/AddRole';
import PrivilegesDetails from './modal/PrivilegesDetails';
import { API_USER } from '../../config/constants';
import HttpService from '../../config/http.service';
import { Toast } from '../../services';
import DeleteConfirm from '../../components/DeleteConfirm';

const RoleManagement = ({ data }: any) => {
    const { roleList, setIsLoad } = data;
    const [isPrivilegesOpen, setIsPrivilegesOpen] = useState(false);
    const [isAddPrivilegeOpen, setIsAddPrivilegeOpen] = useState(false);
    const [isAddRoleOpen, setIsAddRoleOpen] = useState(false);
    const [role, setRole] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [selectedItem, setSelectedItem] = useState({} as any);
    const [isOpenDeleteConfirm, setIsOpenDeleteConfirm] = useState(false)
    const addEditRole = (role: any, type: boolean) => {
        setRole(role)
        setIsEdit(type)
        setIsAddRoleOpen(true)
    }

    const handleDelete = (item: any) => {
        setIsOpenDeleteConfirm(true);
        setSelectedItem(item);
    }

    const deleteItem = () => {
        HttpService.deleteRequest(`${API_USER.DELETE_ROLE}/${selectedItem.id}`).then(
            (res: any) => {
                Toast("Role deleted successfully.", "success");
                setIsLoad(true);
                setIsOpenDeleteConfirm(false);
                setSelectedItem({});
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
    }

    return (
        <div className="p-20 wk-card-container mb-0 rounded-3 box-shadow">
            <div className="wk-row">
                <div className="wk-col-12 text-right">
                    <ButtonFieldIcon size={'small16px'}>
                        <button
                            type="button"
                            id="showPrevileges"
                            title="Privileges Details"
                            className="mr-5" onClick={() => setIsPrivilegesOpen(true)}>
                            <Iconsvg name="info" color="#005b92"></Iconsvg>
                            <Iconsvg name="info" isFill color="#005b92"></Iconsvg>
                            <SrOnly>Info</SrOnly>
                        </button>
                    </ButtonFieldIcon>
                    <Tooltip identifier="tooltip-top"
                        position="top"
                        targetSelector="#showPrevileges">
                        <TooltipBody slot="tooltipBody">Privileges Details</TooltipBody>
                    </Tooltip>
                    <ButtonField size={'small'} mode={'ghost'}>
                        <button type="button" className="mr-5" onClick={() => setIsAddPrivilegeOpen(true)}>
                            Add Privileges
                        </button>
                    </ButtonField>
                    <ButtonField size={'small'} mode={'ghost'}>
                        <button type="button" className="mr-5" onClick={() => addEditRole({}, false)}>
                            Add Role
                        </button>
                    </ButtonField>
                </div>
            </div>
            <div className="wk-row mt-10">
                <div className="wk-col-12">
                    <table className="wk-table wk-table-bordered wk-table-small">
                        <thead>
                            <tr>
                                <th style={{ width: '250px' }}>Role</th>
                                <th>Privileges</th>
                                <th style={{ width: '80px' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {roleList && roleList.map((item: any) => (
                                <tr key={item.id}>
                                    <td>{item.name}</td>
                                    <td><span>{item.privilegeString}</span></td>
                                    <td>
                                        <span className="wk-icon-pencil mr-10 cursor" title="Edit role"
                                            onClick={() => addEditRole(item, true)}></span>
                                        <span className="wk-icon-trash cursor" title="Delete role" onClick={() => handleDelete(item)}></span>
                                    </td>
                                </tr>
                            ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <AddPrivilege isAddPrivilege={isAddPrivilegeOpen} setIsAddPrivilegeOpen={setIsAddPrivilegeOpen} />
            <PrivilegesDetails isPrivilegesOpen={isPrivilegesOpen} setIsPrivilegesOpen={setIsPrivilegesOpen} />
            {isAddRoleOpen && <AddRole isAddRoleOpen={isAddRoleOpen} setIsAddRoleOpen={setIsAddRoleOpen} role={role} isEdit={isEdit} setIsLoad={setIsLoad} />}
            {isOpenDeleteConfirm && <DeleteConfirm data={{ isOpenDeleteConfirm, setIsOpenDeleteConfirm, deleteItem, message: `Are you sure you want to delete?` }} />}
        </div>
    );
};

export default RoleManagement;
